import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
class Page extends Component {
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "app-container",
      id: "knowledge-content-ui-app",
      className: "app-container",
      children: children
    });
  }
}
export default Page;